export const footerContent = {
  signup: {
    title: "Stay tuned to the frequency",
    placeholder: "EMAIL ADDRESS",
    button: "JOIN"
  },
  quote: "Connection is the first step of regeneration",
  columns: {
    movement: [
      { label: "About", url: "/about" },
      { label: "Goals", url: "/goals" },
      { label: "Contact", url: "/contact" }
    ],
    shop: [
      { label: "NFT (0.23 SOL)", url: "/shop" },
      { label: "Physical Art ($100)", url: "/shop" }
    ],
    connect: [
      { label: "Instagram", url: "https://instagram.com", external: true },
      { label: "X / Twitter", url: "https://twitter.com", external: true }
    ]
  }
};